import * as React from 'react';

var _path, _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgProgrammableWallet = function SvgProgrammableWallet(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_66_24744",
        width: 80,
        height: 80,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#D9D9D9",
        d: "M0 0h80v80H0z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_66_24744)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_66_24744)",
        fillOpacity: 0.16,
        d: "M20.578 70.906q-1.9 0-3.24-1.336Q16 68.233 16 66.328v-43.75q0-1.9 1.338-3.24Q18.679 18 20.579 18h43.75q1.904 0 3.242 1.338 1.335 1.34 1.336 3.24v9.407q1.138.338 1.977 1.152 1.431 1.39 1.431 3.692v15.267q0 2.284-1.43 3.682a4.7 4.7 0 0 1-1.978 1.16v9.39q0 1.904-1.336 3.242-1.337 1.335-3.242 1.336z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_66_24744)",
        d: "M52.13 45.553q2.1 0 3.616-1.517t1.516-3.56q0-2.173-1.516-3.648t-3.615-1.475q-2.1 0-3.615 1.475-1.517 1.476-1.517 3.647 0 2.044 1.517 3.561t3.615 1.517M16.579 66.906q-1.9 0-3.24-1.336Q12 64.233 12 62.328v-43.75q0-1.9 1.338-3.24Q14.678 14 16.578 14h43.75q1.904 0 3.242 1.338 1.336 1.34 1.336 3.24v11.014h-2.544V18.578q0-.89-.572-1.462-.573-.573-1.463-.572H16.578q-.89 0-1.462.572-.573.572-.573 1.462v43.75q0 .89.573 1.462.572.572 1.462.572h43.75q.89 0 1.462-.572.572-.573.572-1.462V51.333h2.544v10.995q0 1.904-1.336 3.242-1.337 1.335-3.243 1.336zm27.878-13.729q-2.24 0-3.67-1.399t-1.43-3.682V32.83q0-2.302 1.43-3.692t3.67-1.39H63.15q2.302 0 3.732 1.39t1.431 3.692v15.267q0 2.284-1.43 3.682-1.431 1.4-3.733 1.399zm19.28-2.544a2 2 0 0 0 1.43-.572q.605-.572.605-1.462V32.326q0-.826-.605-1.43a1.96 1.96 0 0 0-1.43-.605H43.934q-.827 0-1.43.605-.605.604-.605 1.43V48.6q0 .89.604 1.462.605.573 1.431.572z"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_66_24744",
        x1: 16.588,
        x2: 71.53,
        y1: 44.453,
        y2: 44.453,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_66_24744",
        x1: 12.588,
        x2: 67.53,
        y1: 40.453,
        y2: 40.453,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgProgrammableWallet as ReactComponent };
//# sourceMappingURL=ProgrammableWallet.svg.es.js.map
